<template>
  <v-flex>
    <vue-markdown
      class="mb-2"
      style="font-weight: bold;"
      :html="true"
      v-if="getTemplateByName('FIRST_STEP_HEADER_TITLE') != null"
    >{{getTemplateByName("FIRST_STEP_HEADER_TITLE").content}}</vue-markdown>

    <vue-markdown
      class="mb-4"
      :html="true"
      v-if="getTemplateByName('FIRST_STEP_HEADER_CONTENT') != null"
    >{{getTemplateByName("FIRST_STEP_HEADER_CONTENT").content}}</vue-markdown>

    <v-list class="ticket-types-list ma-0 pa-0" multiline>
      <v-list-item>
        <v-list-item-title>
          <div class="types-header row">
            <v-flex xs5 sm6 md6 class="pl-3">Ticket Type</v-flex>
            <v-flex xs2 sm2 md2>Price (€)</v-flex>
            <v-flex
              xs5
              sm3
              md3
              class="px-4"
              style=" white-space: normal;text-align: center;"
            >Ticket Count</v-flex>
          </div>
        </v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-flex>
        <v-flex v-for="(groupProduct, groupProductIndex) in groupProducts" :key="groupProductIndex">
          <GroupProduct
            :groupProduct="groupProduct"
            :value="groupProductCount(groupProduct)"
            @change="groupProductCountUpdate"
          />
          <v-divider></v-divider>
        </v-flex>
      </v-flex>
      <v-flex>
        <v-flex v-for="(product, productIndex) in singleProducts" :key="productIndex">
          <SingleProduct
            :product="product"
            :value="singleProductCount(product.productType)"
            @change="singleProductCountUpdate"
          />
          <v-divider></v-divider>
        </v-flex>
      </v-flex>
      <div class="row item-padding">
        <v-flex xs5 sm6 md6 class="px-3 type-value grey--text">Sub Total</v-flex>
        <v-flex xs2 sm2 md2>{{subTotal}}</v-flex>
      </div>
      <v-divider></v-divider>
      <div class="row item-padding">
        <v-flex xs5 sm6 md6 class="px-3 type-value grey--text">VAT</v-flex>
        <v-flex xs2 sm2 md2>{{totalVat}}</v-flex>
      </div>
      <v-divider></v-divider>
      <div class="row item-padding" style="font-weight: bold;">
        <v-flex xs5 sm6 md6 class="px-3">Total Price (incl. VAT)</v-flex>
        <v-flex xs2 sm2 md2 style=" white-space: nowrap;">{{totalPrice}}</v-flex>
      </div>
      <v-divider></v-divider>
    </v-list>
    <v-layout row class="mt-3">
      <v-flex xs8 sm6 md6 class="promo-code-input">
        <v-text-field
          placeholder="Your promo code"
          label="Promo code"
          :value="discountCode"
          @change="v => discountCode = v"
          class="ml-3 mt-3"
          @keyup.enter="discountCodeCheck"
          :disabled="disableDiscountCodeInput"
          prepend-icon="redeem"
        ></v-text-field>
      </v-flex>
      <div class="col-4 promo-code-submit centered-vertically">
        <v-btn
          :color="disableDiscountCodeInput ? 'positive' : 'primary'"
          :outlined="!disableDiscountCodeInput"
          @click="discountCodeCheck"
          :disabled="disableDiscountCodeInput"
        >Apply</v-btn>
      </div>
    </v-layout>
    <div
      :class="{'text-right': $vuetify.breakpoint.smAndUp, 'text-center': $vuetify.breakpoint.xs}"
      data-aos="fade-right"
      data-aos-offset="30"
    >
      <v-btn
        class="mb-5"
        color="primary"
        @click.native="nextStep"
        :disabled="this.tickets.length === 0"
      >
        Continue
        <v-icon right>navigate_next</v-icon>
      </v-btn>
    </div>
  </v-flex>
</template>

<script>
import VueMarkdown from "vue-markdown";
import notClientData from "../mixins/notClientData";
import helperMethods from "../mixins/helperMethods";
import SingleProduct from "@/components/SingleProduct";
import GroupProduct from "@/components/GroupProduct";
import totalPrices from "../mixins/totalPrices";

export default {
  components: {
    VueMarkdown,
    SingleProduct,
    GroupProduct
  },
  props: {
    disableDiscountCodeInput: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  mixins: [notClientData, helperMethods, totalPrices],
  methods: {
    singleProductCountUpdate(update) {
      let newAmount = update.amount;
      let product = this.productByType(update.productType);

      let ticketsClone = _.cloneDeep(this.tickets);

      let currentAmount = this.singleProductCount(product.productType);
      if (currentAmount < newAmount) {
        let toAdd = newAmount - currentAmount;

        this._.times(toAdd, t => {
          ticketsClone.push(
            this.ticket(product.productType, product.vatRate, product.price)
          );
        });
      }
      if (currentAmount > newAmount) {
        let toRemove = currentAmount - newAmount;
        let totalTickets = ticketsClone.length;

        for (let i = totalTickets - 1; i >= 0; i--) {
          if (ticketsClone[i].productType === product.productType) {
            ticketsClone.splice(i, 1);
            toRemove--;
            if (toRemove === 0) break;
          }
        }
      }
      ticketsClone = this._.sortBy(ticketsClone, ["productType"]);

      this.tickets = ticketsClone;
    },
    groupProductCountUpdate(update) {
      let newAmount = update.amount;
      let productLabel = update.productLabel;

      let ticketsClone = _.cloneDeep(this.tickets);

      let groupProduct = this._.find(this.groupProducts, {
        productLabel: productLabel
      });
      let groupTypes = this._.map(groupProduct.products, "productType");
      let currentAmount = this.groupProductCount(groupProduct);

      if (currentAmount < newAmount) {
        let toAdd = newAmount - currentAmount;

        this._.times(toAdd, t => {
          ticketsClone.push(this.typedTicket(groupProduct.products));
        });
      }
      if (currentAmount > newAmount) {
        let toRemove = currentAmount - newAmount;
        let totalTickets = ticketsClone.length;

        for (let i = totalTickets - 1; i >= 0; i--) {
          if (groupTypes.indexOf(ticketsClone[i].productType) > -1) {
            ticketsClone.splice(i, 1);
            toRemove--;
            if (toRemove === 0) break;
          }
        }
      }
      ticketsClone = this._.sortBy(ticketsClone, ["productType"]);
      this.tickets = ticketsClone;
    },
    singleProductCount(productType) {
      return this.tickets.filter(t => t.productType === productType).length;
    },
    groupProductCount(groupProduct) {
      const groupTypes = this._.map(groupProduct.products, "productType");
      return this.tickets.filter(t => groupTypes.indexOf(t.productType) > -1)
        .length;
    },
    typedTicket(availableProducts) {
      return {
        productType: availableProducts[0].productType,
        vatRate: availableProducts[0].vatRate,
        price: availableProducts[0].price,
        firstName: "",
        lastName: "",
        title: "",
        email: "",
        availableProducts: availableProducts,
        typeSelected: false
      };
    },
    ticket(productType, vatRate, price) {
      return {
        productType: productType,
        vatRate: vatRate,
        price: price,
        firstName: "",
        lastName: "",
        title: "",
        email: ""
      };
    },
    discountCodeCheck() {
      this.$emit("change", {});
    },
    nextStep() {
      this.$gtm.trackEvent({
        category: "tickets-continue-button",
        action: "click",
        label: this.tickets.length.toString(),
        value: Math.floor(parseFloat(this.totalPrice)),
        noninteraction: false
      });
      this.scrollToTop();
      this.currentStep = 2;
    }
  }
};
</script>

<style>
</style>